export default __webpack_public_path__ + "static/garden_design0-c50ce0efcb8a9b275a0e36cbeb65a062.webp";